import { UPDATE_FRONT_STYLE_PARKING } from "./frontStyleParkingReducer"

export const updateFrontStyleParking = (status) => ({
    type: UPDATE_FRONT_STYLE_PARKING,
    payload: status
})
